
import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProjectList from './components/ProjectList';
import About from './components/About';
import Footer from './components/Footer';
import FeedbackModal from './components/FeedbackModal';
import FeedbackButton from './components/FeedbackButton';

const App: React.FC = () => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#1E293B] selection:bg-blue-100">
      <Header />
      <main>
        <Hero />
        <ProjectList />
        <About />
      </main>
      <Footer />
      
      {/* Feedback UI */}
      <FeedbackButton onClick={() => setIsFeedbackOpen(true)} />
      <FeedbackModal isOpen={isFeedbackOpen} onClose={() => setIsFeedbackOpen(false)} />
    </div>
  );
};

export default App;
